module.exports = __webpack_public_path__ + "assets/img/img-prize1-d4bdc58e.png";